import React, { useEffect, useState, useRef } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  useTheme,
} from "@material-ui/core";

import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createSignee, getCandidateReferredFrom, getCategories } from "../../store/action";
import Notification from "../../components/Notification/Notification";
import axios from "axios";
import apiConfigs from "../../config/config";
import history from "../../utils/HistoryUtils";
import UtilService from "../../helper/service";
import { getStaffDetail, getCompilanceOfficerDetail } from "../../store/action/staff/staffAction";
import { getUmbrellDetail } from "../../store/action/umbrella/umbrellaAction";
import { useGooglePlaceAutoCompleteForCandidate } from "../../components/GoogleAPI/google_place_autocomplete";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { customEnLocale } from "../../helper/customLocale";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
// import Autocomplete from '@mui/material/Autocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 24,
    background: theme.palette.background.main
  },
  radioGroup: {
    flexDirection: "row",
  },
  formControl: {
    width: "100%",
  },
  mainTitle: {
    fontSize: 18,
    color: theme.primary,
    fontWeight: "500",
  },
  footerBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "5px",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const CreateSignee = () => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [personName, setPersonName] = useState([]);
  const [selected, setSelected] = useState([]);
  const { register, handleSubmit, formState: { errors }, clearErrors } = useForm({
    mode: "onChange", // validate as user types
  });
  const { createSigneeSuccess, createSigneeError, getCategoriesItem } = useSelector((state) => state.signee);
  const [signeeNotify, setSigneeNotify] = useState(false);

  // for today date selection
  const dateNow = new Date();
  const year = dateNow.getFullYear();
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month =
    monthWithOffset.toString().length < 2
      ? `0${monthWithOffset}`
      : monthWithOffset;
  const date =
    dateNow.getUTCDate().toString().length < 2
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();
  const materialDateInput = `${year}-${month}-${date}`;
  const disFutureDate = UtilService.disabledPastDate();
  const [staff, setStaff] = useState([]);
  const [compilanceOfficer, setCompilanceOfficer] = useState([]);

  const [umbrella, setUmbrella] = useState([]);
  const [categories, setCategories] = useState([]);
  // for today date selection

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    contact_number: "",
    date_of_birth: "",
    candidate_id: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    city: "",
    postcode: "",
    email: "",
    // candidate_referred_from:"",
    nationality: "",
    date_registered: materialDateInput,
    organization_id: "",
    nmc_dmc_pin: "",
    gender: "Male",
    registration_status: "No Restriction",
    payment_method: "PAYE",
    npm_revalidation_date: "",
    revalidation_due_date: "",
    apprisal_due_date: "",
    hrmc_engagement_reason: "",
    staff_id: "",
    name_of_bank: "",
    umbrella_id: "",
    account_number: "",
    sort_code: "",
    ni_number: "",
    speciality: [],
    name_of_kin: "",
    address_of_kin: "",
    contact_of_kin: "",
    econtact_of_kin: "",
    latitude: "",
    longitude: "",
    compilance_officer_id: "",
    categoryItem: ""
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };
  const hanleAutoComplete = (event, newValue) => {
    let numbers = newValue.map(item => item.id);
    console.log(numbers, "numbers");
    setPersonName(numbers);
  }
  const handleChangeDate = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };
  const dateHandler = (name, date) => {
    setData({ ...data, [name]: date });
  }
  const handleChangeReValidDueDate = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleChangeAprisalDueDate = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleUmbrellaChange = (event) => {
    let umbrelaDetils = umbrella?.data.find((e) => e.id == event.target.value);
    if (umbrelaDetils != null && umbrelaDetils != undefined) {
      data.umbrella_id = umbrelaDetils.id;
      data.name_of_bank = umbrelaDetils.bank_name;
      data.sort_code = umbrelaDetils.bank_sort_code;
      data.account_number = umbrelaDetils.bank_account_number;
    }
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const getCandidateId = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(`${apiConfigs.API_URL}api/organization/get-candidate`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setData({
          ...data,
          candidate_id: parseFloat(response.data.data.candidate_id),
        });
      })
      .catch((error) => {
        console.error("error.message", error.message);
      });
  };

  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getCompilanceOfficer = async () => {
    dispatch(
      getCompilanceOfficerDetail((result) => {
        if (result?.data) {
          setCompilanceOfficer(result);
        }
      })
    );
  };

  const getUmbrella = async () => {
    dispatch(
      getUmbrellDetail((result) => {
        if (result?.data) {
          setUmbrella(result);
        }
      })
    );
  };

  const signeeSubmitData = () => {
    let payload = {
      ...data,
      date_of_birth: data?.date_of_birth ? moment(data?.date_of_birth).format("YYYY-MM-DD") : "",
      npm_revalidation_date: data?.npm_revalidation_date ? moment(data?.npm_revalidation_date).format("YYYY-MM-DD") : "",
      revalidation_due_date: data?.revalidation_due_date ? moment(data?.revalidation_due_date).format("YYYY-MM-DD") : "",
      apprisal_due_date: data?.apprisal_due_date ? moment(data?.apprisal_due_date).format("YYYY-MM-DD") : "",
      date_registered: data?.date_registered ? moment(data?.date_registered).format("YYYY-MM-DD") : "",
      categoryItem: personName
    }
    dispatch(createSignee(payload));
    setSigneeNotify(true);
  };

  const backPage = () => {
    history.goBack();
  };
  const address1Ref = useRef();
  const googleAutoCompleteSvc = useGooglePlaceAutoCompleteForCandidate();
  let autoComplete = "";

  const handleAddressSelect = async () => {
    let addressObj = await googleAutoCompleteSvc.getFullAddress(autoComplete);
    setData((prevData) => ({
      ...prevData,
      city: addressObj.locality,
      address_line_2: addressObj.address_line_2,
      postcode: addressObj.postcode,
      address_line_1: addressObj.address_line_1,
      latitude: addressObj.latitude,
      longitude: addressObj.longitude,
    }));
  };

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    if (getCategoriesItem.length > 0) {
      setCategories(getCategoriesItem);
    }
  }, [getCategoriesItem]);

  useEffect(() => {
    getCategories();
    getCandidateId();
    getStaff();
    getCompilanceOfficer();
    getUmbrella();
    dispatch(getCandidateReferredFrom());
    async function loadGoogleMaps() {
      // initialize the Google Place Autocomplete widget and bind it to an input element.
      // eslint-disable-next-line
      autoComplete = await googleAutoCompleteSvc.initAutoComplete(address1Ref.current, handleAddressSelect);
    }
    loadGoogleMaps();
  }, []);

  return (
    <>
      {signeeNotify && createSigneeSuccess?.message && (
        <Notification data={createSigneeSuccess?.message} status="success" />
      )}
      {signeeNotify && createSigneeError?.message && (
        <Notification data={createSigneeError?.message} status="error" />
      )}

      <Paper className={classes.root} sx={{ p: 1 }}>
        <form onSubmit={handleSubmit(signeeSubmitData)} autoComplete="off">
          <Grid container spacing={2}>
            {/* Personal Information Section */}
            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.listItem }} variant="h6">
                Personal Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="candidate_id"
                label="Candidate Id"
                variant="outlined"
                name="candidate_id"
                value={data?.candidate_id}
                onChange={handleChange}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="first_name"
                label="First name"
                variant="outlined"
                name="first_name"
                {...register("first_name", { required: "Please enter first name" })}
                error={!!errors.first_name}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="last_name"
                label="Last name"
                variant="outlined"
                name="last_name"
                {...register("last_name", { required: "Please enter last name" })}
                error={!!errors.last_name}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="email"
                label="Email"
                variant="outlined"
                name="email"
                {...register("email", {
                  required: "Please enter email",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Enter a valid e-mail address",
                  },
                })}
                error={!!errors.email}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="contact_number"
                label="Contact number"
                variant="outlined"
                name="contact_number"
                type="text"
                value={data?.contact_number}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="date_of_birth"
                  value={data?.date_of_birth || "01-01-1970"}
                  label="Date of birth"
                  name="date_of_birth"
                  variant="outlined"
                  onChange={(e) => dateHandler("date_of_birth", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth variant="outlined" />
                  )}
                  inputFormat="dd-MMM-yyyy"
                  fullWidth
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" className={classes.formControl} error={!!errors.gender} >
                <InputLabel>Gender </InputLabel>
                <Select
                  value={data?.gender || ""}
                  name="gender"
                  label="Gender"
                  onChange={handleChange}
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Address Section */}
            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.listItem }} variant="h6">
                Address Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_line_1"
                label="Address Line 1"
                variant="outlined"
                name="address_line_1"
                {...register("address_line_1", { required: true })}
                value={data?.address_line_1}
                inputRef={address1Ref}
                onChange={handleChange}
                error={!!errors.address_line_1}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_line_2"
                label="Address line 2"
                variant="outlined"
                name="address_line_2"
                {...register("address_line_2")}
                onChange={handleChange}
                fullWidth
                value={data?.address_line_2}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="City"
                label="City"
                variant="outlined"
                name="city"
                {...register("city")}
                value={data?.city}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="postcode"
                label="Postcode"
                variant="outlined"
                name="postcode"
                {...register("postcode")}
                value={data?.postcode}
                fullWidth
              />
            </Grid>

            {/* Personal Information Section */}
            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.listItem }} variant="h6">
                Registration Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="nationality"
                label="Nationality"
                variant="outlined"
                name="nationality"
                value={data?.nationality}
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="date_registered"
                  label="Date Registered"
                  type="date"
                  name="date_registered"
                  variant="outlined"
                  value={data?.date_registered}
                  defaultValue={materialDateInput}
                  onChange={(e) => dateHandler("date_registered", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField
                    fullWidth
                    variant="outlined"  {...props} />}
                  inputFormat="dd-MMM-yyyy"

                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="nmc_dmc_pin"
                label="Registered Body Pin"
                variant="outlined"
                name="nmc_dmc_pin"
                value={data?.nmc_dmc_pin}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              {/* <FormControl
                variant="outlined"
                className={classes.formControl}
                error={!!errors.staff_id}
              >
                <InputLabel>Consultant</InputLabel>
                <Select
                  value={data.staff_id}
                  label="Consultant"
                  name="staff_id"
                  {...register("staff_id", { required: "The Staff field is required." })}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="">Select Consultant</MenuItem>
                  {staff?.data &&
                    staff?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index}>
                          {trustList.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl> */}
              <Autocomplete
                options={staff?.data || []}
                getOptionLabel={(option) => option?.name || ""}
                value={staff?.data?.find((s) => s.id === data?.staff_id) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "staff_id",
                      value: newValue ? newValue.id : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Consultant"
                    variant="outlined"
                    error={!!errors?.staff_id}
                    helperText={errors?.staff_id ? errors.staff_id.message : ""}
                    required
                    fullWidth
                  />
                )}
              />

            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="npm_revalidation_date"
                  label="SOE Registration Date"
                  type="date"
                  name="npm_revalidation_date"
                  variant="outlined"
                  value={data?.npm_revalidation_date || null}
                  onChange={(e) => dateHandler("npm_revalidation_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth variant="outlined" />
                  )}
                  inputFormat="dd-MMM-yyyy"
                  fullWidth
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="revalidation_due_date"
                  label="Revalidation Due Date"
                  type="date"
                  name="revalidation_due_date"
                  variant="outlined"
                  value={data?.revalidation_due_date || null}
                  onChange={(e) => dateHandler("revalidation_due_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  renderInput={props => <TextField variant="outlined" fullWidth  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="apprisal_due_date"
                  label="Appraisal Due Date"
                  type="date"
                  name="apprisal_due_date"
                  variant="outlined"
                  value={data?.apprisal_due_date || null}
                  onChange={(e) => dateHandler("apprisal_due_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField variant="outlined" fullWidth  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" className={classes.formControl} error={!!errors.registration_status}>
                <InputLabel>Registration Status</InputLabel>
                <Select
                  value={data.registration_status}
                  name="registration_status"
                  label="Registration Status"
                  onChange={handleChange}
                >
                  <MenuItem value="No Restriction" key="No Restriction">No Restriction</MenuItem>
                  <MenuItem value="Caution Order" key="Caution Order">Caution Order</MenuItem>
                  <MenuItem value="Restricted" key="Restricted">Restricted</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              {/* <FormControl
                variant="outlined"
                className={classes.formControl}
                error={!!errors.compilance_officer_id}
              >
                <InputLabel>Compliance Officer</InputLabel>
                <Select
                  value={data.compilance_officer_id}
                  label="Compliance Officer"
                  name="compilance_officer_id"
                  onChange={handleChange}
                >
                  <MenuItem value="">Select Compliance Officer</MenuItem>
                  {compilanceOfficer?.data &&
                    compilanceOfficer?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index}>
                          {trustList.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl> */}
              <Autocomplete
                options={compilanceOfficer?.data || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  compilanceOfficer?.data?.find(
                    (c) => c.id === data?.compilance_officer_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "compilance_officer_id",
                      value: newValue ? newValue.id : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Compliance Officer"
                    variant="outlined"
                    error={!!errors?.compilance_officer_id}
                    helperText={
                      errors?.compilance_officer_id
                        ? errors.compilance_officer_id.message
                        : ""
                    }
                    fullWidth
                  />
                )}
              />

            </Grid>

            {/* Categories dropdown  */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>

                <Autocomplete
                  multiple
                  id="tags-outlined"
                  name="categoryItem"
                  options={categories}
                  getOptionLabel={(option) => option.name}
                  personName
                  onChange={hanleAutoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Categories"
                      variant="outlined"
                      margin="none"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.listItem }} variant="h6">
                Payroll Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box className="mt-3">
                <Typography variant="h6" >Payment Method</Typography>
                <RadioGroup
                  name="payment_method"
                  value={data?.payment_method || ""}
                  onChange={handleChange}
                  className={classes.radioGroup}
                >
                  <FormControlLabel value="PAYE" control={<Radio />} label="PAYE" />
                  <FormControlLabel value="Umbrella" control={<Radio />} label="Umbrella" />
                </RadioGroup>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={errors.umbrella_id ? true : false}
              >
                <InputLabel>Umbrella Name</InputLabel>
                <Select
                  value={data.umbrella_id}
                  label="Umbrella Name"
                  name="umbrella_id"
                  {...register("umbrella_id", {
                    required:
                      data?.payment_method === "Umbrella" ? true : false,
                  })}
                  // required={data?.payment_method === "Umbrella" ? true : false}
                  disabled={data?.payment_method === "PAYE" ? true : false}
                  onChange={handleUmbrellaChange}
                >
                  <MenuItem value="">Select Umbrella</MenuItem>
                  {umbrella?.data &&
                    umbrella?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index}>
                          {trustList.name_umbrella}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
              // required
              // error={errors.hrmc_engagement_reason ? true : false}
              >
                <InputLabel>HRMC Engagement Reason </InputLabel>
                <Select
                  value={data.hrmc_engagement_reason}
                  name="hrmc_engagement_reason"
                  label="HRMC Engagement Reason  Required"
                  onChange={handleChange}
                >
                  <MenuItem value="Self Employed" key="Self Employed">
                    {" "}
                    Self Employed
                  </MenuItem>
                  <MenuItem value="Partnership" key="Partnership">
                    {" "}
                    Partnership
                  </MenuItem>
                  <MenuItem
                    value="Limited Liability Partner"
                    key="Limited Liability Partner"
                  >
                    {" "}
                    Limited Liability Partner
                  </MenuItem>
                  <MenuItem
                    value="Ltd co inclu Personal Service"
                    key="Ltd co inclu Personal Service"
                  >
                    {" "}
                    Ltd co inclu Personal Service
                  </MenuItem>
                  <MenuItem value="Non-UK engagement" key="Non-UK engagement">
                    {" "}
                    Non-UK engagement
                  </MenuItem>
                  <MenuItem value="Another party PAYE" key="Another party PAYE">
                    {" "}
                    Another party PAYE
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="name_of_bank"
                label="Name of Bank"
                variant="outlined"
                name="name_of_bank"
                type="text"
                value={data?.name_of_bank}
                disabled={data?.payment_method === "Umbrella" ? true : false}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="account_number"
                label="Account Number"
                variant="outlined"
                name="account_number"
                value={data?.account_number || ""}
                type="text"
                disabled={data?.payment_method === "Umbrella" ? true : false}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="sort_code"
                label="Sort Code"
                variant="outlined"
                name="sort_code"
                value={data?.sort_code || ""}
                type="text"
                disabled={data?.payment_method === "Umbrella" ? true : false}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="ni_number"
                label="NI Number"
                variant="outlined"
                name="ni_number"
                type="text"
                value={data?.ni_number || ""}
                required
                {...register("ni_number", {
                  required: "Please enter ni number",
                })}
                fullWidth
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ color: theme.palette.listItem }} variant="h6">
                Next of Kin
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="name_of_kin"
                label="Name"
                variant="outlined"
                name="name_of_kin"
                type="text"
                value={data?.name_of_kin}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_of_kin"
                label="Address"
                variant="outlined"
                name="address_of_kin"
                value={data?.address_of_kin || ""}
                type="text"
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="contact_of_kin"
                label="Contact Number"
                variant="outlined"
                name="contact_of_kin"
                value={data?.contact_of_kin || ""}
                type="text"
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="econtact_of_kin"
                label="Emergency Contact Number"
                variant="outlined"
                name="econtact_of_kin"
                type="text"
                value={data?.econtact_of_kin || ""}
                fullWidth
                onChange={handleChange}
              />
            </Grid>

          </Grid>

          <Box className={classes.footerBtn}>
            <Button color="primary" variant="outlined" onClick={backPage}>Cancel</Button>
            <Button color="primary" variant="contained" type="submit" formNoValidate>Submit</Button>
          </Box>
        </form>
      </Paper>
    </>
  );
};

export default CreateSignee;
